var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1026 5100 c-517 -62 -934 -464 -1011 -977 -22 -146 -22 -2980 0 -3126 63 -421 365 -783 765 -920 193 -66 86 -62 1780 -62 1694 0 1587 -4 1780 62 400 137 702 499 765 920 22 146 22 2980 0 3126 -63 421 -365 784 -765 920 -192 65 -71 61 -1735 63 -830 1 -1541 -2 -1579 -6z m1359 -1817 c137 -183 253 -332 256 -333 4 0 139 151 300 335 l292 335 180 0 c171 0 179 -1 165 -17 -50 -59 -725 -833 -745 -854 l-24 -26 454 -601 c250 -330 458 -605 461 -611 5 -8 -96 -11 -356 -11 l-363 1 -282 370 -282 369 -323 -370 -323 -370 -178 0 c-146 0 -177 2 -170 13 4 8 190 222 413 476 223 254 406 465 407 469 2 4 -195 266 -437 582 -242 316 -440 576 -440 577 0 2 168 2 372 1 l373 -3 250 -332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1816 3408 c4 -7 297 -392 652 -855 l644 -843 100 0 100 0 -29 38 c-15 21 -306 406 -646 855 l-618 817 -105 0 c-81 0 -104 -3 -98 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterX);
export default __webpack_public_path__ + "static/media/twitter-x.45276ec151ef0d88345d027e05404a29.svg";
export { ForwardRef as ReactComponent };